module.exports = __webpack_public_path__ + "media/images/undraw_contrast_vb82-fa81a915cdd3118e7891d12c600a2d90.svg";